export const rupiah = (n) => {
  const v = Number(n || 0);
  return "Rp " + v.toLocaleString("id-ID");
};

export const rupiahShort = (n) => rupiah(n);

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return "-"; }
};

// Same as fmtDate but includes the time-of-day — used for follow-up dates, where
// "5 hari lagi" without a time is ambiguous about which reminder tier applies.
export const fmtDateTime = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return "-"; }
};

export const AGING = {
  new: { label: "Baru", color: "#10B981", border: "border-l-emerald-500/40" },
  normal: { label: "Normal", color: "#3B82F6", border: "border-l-blue-500/40" },
  attention: { label: "Perlu Perhatian", color: "#F59E0B", border: "border-l-amber-500/45" },
  critical: { label: "Kritis", color: "#EF4444", border: "border-l-red-500/45" },
  none: { label: "", color: "#3f3f46", border: "border-l-zinc-700/60" },
};

export const PRIORITY = {
  Hot: "bg-red-500/15 text-red-400 border-red-500/30",
  Warm: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  Cold: "bg-blue-500/15 text-blue-400 border-blue-500/30",
};
